import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltSingleEditorModePanelRequestAccessWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-single-editor-mode-panel-request-access-wireframe", __assign({}, transformedProps), children));
};
export default VeltSingleEditorModePanelRequestAccessWireframe;
